import { Component, OnInit, Input, forwardRef, Output, EventEmitter} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';

export const LAAS_INPUT_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextAreaSetComponent),
  multi: true
};


@Component({
  selector: 'laas-text-area-set',
  templateUrl: './text-area-set.component.html',
  styleUrls: ['./text-area-set.component.scss'],
  providers: [LAAS_INPUT_ACCESSOR]
})
export class TextAreaSetComponent implements OnInit, ControlValueAccessor {

  @Input() maxlength: any;
  @Input() row: any;
  @Input() col: any;
  @Input() style: any;
  @Input() inputValue: any;

  @Output() onBlur: EventEmitter<any> = new EventEmitter();
  @Output() onPress: EventEmitter<any> = new EventEmitter();

  value: any;
  control: FormControl = new FormControl();
  changeText: boolean;
  onChange!: (value: string) => void;
  onTouched!: () => void;
  disabled = false;


  constructor() {
    this.changeText = false;
    this.value = this.inputValue;
   }

  blur(event: any): void{
    this.changeText = false
    this.onBlur.emit({
      originalevent:event,
      value: this.value
    });
  }
  focus(event: any): void{
    this.changeText = true
    this.onPress.emit({
      originalevent:event,
      value: this.value
    });
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    console.log("value",this.value)
  }




}
